import {RoleName} from "../../../administration/users/Role";
import {User} from "../../../administration/users/User";
import {hasAccountServiceRole} from "../../../administration/users/AccountServiceRoles";

export type WithRestrictedVisibility = {
  visibleForRoles?: RoleName[]
}

export function isVisible(user: User, withRestrictedVisibility: WithRestrictedVisibility): boolean {
  // No restriction
  if (withRestrictedVisibility.visibleForRoles === undefined) {
    return true
  }
  let matchingRole = withRestrictedVisibility.visibleForRoles.find(role => {
    return hasAccountServiceRole(user, role);
  });
  return matchingRole !== undefined;
}

